import { DataCache, QueryResultsRelationship, ForeignKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { ReservationsDashboardResponse } from 'data/models/ReservationsDashboardResponse';
import { ReservationsListBaseCache } from 'portcall/reservationslistbase/cache';

export class ReservationsDashboardCache extends DataCache {
    ReservationsDashboardResponses = PCCollection(ReservationsDashboardResponse);

    constructor(data : PCCache, rowCache : ReservationsListBaseCache) {
        super();

        new ForeignKeyRelationship(data.Organizations, this.ReservationsDashboardResponses, null, r => r.Organization, r => r.OrganizationId());
        new QueryResultsRelationship(this.ReservationsDashboardResponses, rowCache.ReservationsDashboardRows, r => r.Rows);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/reservationsdashboard/cache.ts